import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    Input,
} from "@angular/core";

import { MeasureYourselfPdf } from "@hermes/api-model-product";
import { WINDOW } from "@hermes/app-core";

/**
 * Component for displaying a PDF download block within a size guide.
 * This component renders a button that allows users to download a PDF.
 */
@Component({
    selector: "h-block-pdf",
    templateUrl: "./block-pdf.component.html",
    styleUrls: ["./block-pdf.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockPdfComponent {
    public labelPdf!: string | undefined;
    public urlPdf!: string;

    constructor(@Inject(WINDOW) private window: Window) {}

    @Input({ required: true })
    public set blockMeasureYourself(blockMeasureYourself: MeasureYourselfPdf) {
        if (blockMeasureYourself.url) {
            this.labelPdf = blockMeasureYourself.label;
            this.urlPdf = blockMeasureYourself.url;
        }
    }

    public downloadFile(): void {
        if (this.urlPdf) {
            this.window.open(this.urlPdf, "_blank", "noopener,noreferrer");
        }
    }
}
